// extracted by mini-css-extract-plugin
export default {"top":"styles_top__0+pNR","avatar":"styles_avatar__sZ-4N","subTitle":"styles_subTitle__aa-46","field":"styles_field__Sal-V","relationships":"styles_relationships__3sh4V"};